import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'src/components/buttons-and-actions/button';
import type { LoadedAppShellData } from 'src/components/layout/app-shell/use-app-shell-data';
import { useNavigationItems } from 'src/components/layout/app-shell/use-navigation-items';
import { Link } from 'src/components/navigation/link';
import { Heading } from 'src/components/text/heading';
import { useSafeLocalStorage } from 'src/hooks/use-storage';
import { setLocationHref } from 'src/utils/location-usage';

type Props = {
  appShellData: LoadedAppShellData;
};

export const UserNav: FC<Props> = ({ appShellData }) => {
  const navigationItems = useNavigationItems(appShellData);
  const { pathname } = useLocation();
  const safeLocalStorage = useSafeLocalStorage();

  return (
    <div className="grid w-full gap-xs">
      <div className="grid gap-xs rounded-t-xs bg-background-surface-minimal p-lg">
        {appShellData.accounts.current?.organisationName && (
          <Heading mode="title" size="sm">
            {appShellData.accounts.current.organisationName}
          </Heading>
        )}

        <p className="text-label-sm text-foreground-surface-subdued">
          {appShellData.accounts.current?.email}
        </p>
      </div>

      {navigationItems.userNav.switchToShipper && (
        <Button
          onClick={() => {
            safeLocalStorage.setItem('ENFORCE_SHIPPER_ROLE', 'true');
            setLocationHref(PRISMA_CONFIG.angularUrl);
          }}
        >
          Switch to Shipper Role
        </Button>
      )}

      {navigationItems.userNav.switchToTso && (
        <Button
          onClick={() => {
            safeLocalStorage.removeItem('ENFORCE_SHIPPER_ROLE');
            setLocationHref(PRISMA_CONFIG.angularUrl);
          }}
        >
          Switch to TSO Role
        </Button>
      )}

      {navigationItems.userNav.switchToSso && (
        <Button
          onClick={() => {
            safeLocalStorage.removeItem('ENFORCE_SHIPPER_ROLE');
            setLocationHref(PRISMA_CONFIG.angularUrl);
          }}
        >
          Switch to SSO Role
        </Button>
      )}

      {navigationItems.userNav.shipperRolePending && (
        <Button disabled>Shipper Role Awaiting Activation</Button>
      )}

      {navigationItems.userNav.switchAccount && (
        <Link
          to="/login/accounts"
          isActive={pathname === '/login/accounts'}
          data-testid="switch-account-link"
        >
          Switch Account
        </Link>
      )}

      {navigationItems.userNav.logout && (
        <Link to="/logout" data-testid="logout-button">
          {appShellData.accounts.items.length > 1
            ? 'Log Out From All Accounts'
            : 'Log Out'}
        </Link>
      )}
    </div>
  );
};
